export const BACKEND_URL = process.env.REACT_APP_HOST_API;

export const urlMap = {
  // auth
  auth: {
    login: `${BACKEND_URL}/v1/auth/login`,
    clinic_login: `${BACKEND_URL}/v1/auth/clinic-login`,
    doctor_login: `${BACKEND_URL}/v1/auth/doctor-login`,
    admin_login: `${BACKEND_URL}/v1/auth/admin-login`,
    pharmacy_login: `${BACKEND_URL}/v1/auth/pharmacy-login`,
  },
  // user
  user: {
    details: `${BACKEND_URL}/v1/users/:userId`,
  },
  clinic: {
    dashboard: `${BACKEND_URL}/v1/clinics/dashboard/:clinicId`,
    list: `${BACKEND_URL}/v1/clinics?page=pageValue&limit=limitValue`,
    create: `${BACKEND_URL}/v1/clinics`,
    users: `${BACKEND_URL}/v1/clinics/:clinicId/get-members?page=pageValue&limit=limitValue`,
    createUser: `${BACKEND_URL}/v1/clinics/:clinicId/add-member`,
    details: `${BACKEND_URL}/v1/clinics/:clinicId`,
    update: `${BACKEND_URL}/v1/clinics/:clinicId`,
    doctors: `${BACKEND_URL}/v1/clinics/:clinicId/doctor`,
    checkDoctor: `${BACKEND_URL}/v1/clinics/:clinicId/doctor/check`,
    bodyParts: `${BACKEND_URL}/v1/treatments/body-parts`,
    enquires: `${BACKEND_URL}/v1/enquire/clinic/:clinicId?page=pageValue&limit=limitValue`,
  },

  staff: {
    list: `${BACKEND_URL}/v1/users/staff?&page=pageValue&limit=limitValue`,
    create: `${BACKEND_URL}/v1/users`,
    updateUserPassword: `${BACKEND_URL}/v1/users/reset-user-password`,
  },
  images: {
    upload: `${BACKEND_URL}/v1/images/upload?fileName=FileName&folderName=FolderName`,
    privateUploadUrl: `${BACKEND_URL}/v1/images/private/upload-url`,
    privateViewUrl: `${BACKEND_URL}/v1/images/private/view-url`,
    privateViewUrls: `${BACKEND_URL}/v1/images/private/view-urls`,
  },
  packages: {
    create: `${BACKEND_URL}/v1/packages`,
    list: `${BACKEND_URL}/v1/packages/clinic/:clinicId`,
    getDetails: `${BACKEND_URL}/v1/packages/:packageId`,
    delete: `${BACKEND_URL}/v1/packages/:packageId`,
    update: `${BACKEND_URL}/v1/packages/:packageId`,
    publish: `${BACKEND_URL}/v1/packages/:packageId/publish`,
  },
  doctors: {
    getDetails: `${BACKEND_URL}/v1/doctors/:userId`,
    update: `${BACKEND_URL}/v1/doctors/:userId`,
    getAll: `${BACKEND_URL}/v1/doctors`,
  },
  procedures: {
    list: `${BACKEND_URL}/v1/procedures?page=pageValue&limit=limitValue&sortBy=name`,
    add: `${BACKEND_URL}/v1/procedures`,
    remove: `${BACKEND_URL}/v1/procedures/:procedureId`,
    getDetails: `${BACKEND_URL}/v1/procedures/:procedureId`,
    addContent: `${BACKEND_URL}/v1/procedures/:procedureId/content`,
    edit: `${BACKEND_URL}/v1/procedures/:procedureId`,
    search: `${BACKEND_URL}/v1/procedures/search`,
  },

  treatments: {
    all: `${BACKEND_URL}/v1/treatments?page=pageValue&limit=limitValue`,
    bodyParts: `${BACKEND_URL}/v1/treatments/body-parts`,
    procedures: `${BACKEND_URL}/v1/treatments/procedures?body_part={body_part}`,
    concerns: `${BACKEND_URL}/v1/treatments/concerns-by-procedure?body_part={body_part}&procedure={procedure}`,
    treatmentId: `${BACKEND_URL}/v1/treatments/treatment-id-by-procedure?body_part={body_part}&procedure={procedure}&concern={concern}`,
    procedureName: `${BACKEND_URL}/v1/treatments/procedure-name?treatment_id={treatmentId}`,
    data: `${BACKEND_URL}/v1/treatments/get-select-options`,
    create: `${BACKEND_URL}/v1/treatments`,
    update: `${BACKEND_URL}/v1/treatments?treatment_id={treatmentId}`,
    search: `${BACKEND_URL}/v1/treatments/search`,
    byId: `${BACKEND_URL}/v1/treatments/{treatmentId}`,
  },
  concerns: {
    all : `${BACKEND_URL}/v1/concerns?page=pageValue&limit=limitValue`,
    bodyParts : `${BACKEND_URL}/v1/concerns/body-parts`,
    update : `${BACKEND_URL}/v1/concerns/{concernId}`,
    create : `${BACKEND_URL}/v1/concerns`,
    delete : `${BACKEND_URL}/v1/concerns/{concernId}`,
    search: `${BACKEND_URL}/v1/concerns/search/{name}`,
    byId: `${BACKEND_URL}/v1/concerns/{treatmentId}`,
  },
  products: {
    all: `${BACKEND_URL}/v1/products/`,
    create: `${BACKEND_URL}/v1/products`,
    update: `${BACKEND_URL}/v1/products/:productId`,
    delete: `${BACKEND_URL}/v1/products/:productId`,
    byId: `${BACKEND_URL}/v1/products/:productId`,
    search: `${BACKEND_URL}/v1/products/search`,
  },
  telepackages: {
    all: `${BACKEND_URL}/v1/telecare-packages/`,
    create: `${BACKEND_URL}/v1/telecare-packages`,
    update: `${BACKEND_URL}/v1/telecare-packages/:telepackagesId`,
    delete: `${BACKEND_URL}/v1/telecare-packages/:telepackagesId`,
    byId: `${BACKEND_URL}/v1/telecare-packages/:telepackagesId`,
    responses : `${BACKEND_URL}/v1/users-telecare-package-responses/list`,
    edit_responses: `${BACKEND_URL}/v1/users-telecare-package-responses/:userResponseId`,
    update_responses: `${BACKEND_URL}/v1/users-telecare-package-responses/:userResponseId`,
  },

  enquiry: {
    list: `${BACKEND_URL}/v1/enquire?page=pageValue&limit=limitValue`,
    details: `${BACKEND_URL}/v1/enquire/:enquiryId`,
    update: `${BACKEND_URL}/v1/enquire/:enquiryId`,
    comment: {
      add: `${BACKEND_URL}/v1/enquiry-comment`,
      list: `${BACKEND_URL}/v1/enquiry-comment?enquiry_id={enquiryId}`,
    },
  },
  commmunity: {
    list: `${BACKEND_URL}/v1/communities?page=pageValue&limit=limitValue`,
    create: `${BACKEND_URL}/v1/communities`,
    posts: `${BACKEND_URL}/v1/communities/communityId/posts?page=pageValue&limit=limitValue&populate=user_id,community_id`,
    post: `${BACKEND_URL}/v1/communities/communityId/posts/postId`,
    comments: `${BACKEND_URL}/v1/communities/posts/postId/comments?page=pageValue&limit=limitValue&populate=user_id`,
  },
  telehealth: {
    create: `${BACKEND_URL}/v1/telecare-therapies`,
    list: `${BACKEND_URL}/v1/telecare-therapies?clinic_id={clinicId}`,
    getDetails: `${BACKEND_URL}/v1/telecare-therapies/:therapyId`,
    update: `${BACKEND_URL}/v1/telecare-therapies/:therapyId`,
    delete: `${BACKEND_URL}/v1/telecare-therapies/:therapyId`,
    categories: `${BACKEND_URL}/v1/telecare-therapies/categories`,
    search: `${BACKEND_URL}/v1/telecare-therapies/search`,
  },
  questions:{
    types: `${BACKEND_URL}/v1/questions/types`,
    byId: `${BACKEND_URL}/v1/questions/:questionId`,
  },
  prescriptions: {
    generate: `${BACKEND_URL}/v1/prescriptions/response/:responseId`,
    get: `${BACKEND_URL}/v1/prescriptions/response/:responseId`,
    delete: `${BACKEND_URL}/v1/prescriptions/response/:responseId`,
  },
  pharmacy: {
    orders: `${BACKEND_URL}/v1/pharmacy-orders/list`,
    updateStatus: `${BACKEND_URL}/v1/pharmacy-orders/:orderId/status`,
  }
};
